/**
 * Pre-compiled localized messages for DefaultPage component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import defaultPageMessages_en from "./intl/en";
import defaultPageMessages_de from "./intl/de";
import defaultPageMessages_es from "./intl/es";
import defaultPageMessages_fr from "./intl/fr-FR";
import defaultPageMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const defaultPageMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(defaultPageMessages_en),
  de: normalizeMessages(defaultPageMessages_de),
  es: normalizeMessages(defaultPageMessages_es),
  "fr-FR": normalizeMessages(defaultPageMessages_fr),
  "pt-BR": normalizeMessages(defaultPageMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for DefaultPage component
 */
export type DefaultPageMessageKey = "backLink";
